import {Bling} from "./bling";

function applyFieldValidation(formInput, errorId, errorMessage) {
    if (errorMessage) {
        addError(formInput, errorId, errorMessage);
    } else {
        removeError(formInput, errorId);
    }
}

export function isDateOfBirthValid(day, month, year) {
    const ListOfDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (isNaN(day) || isNaN(month) || isNaN(year)){
        return false;
    }
    
    if (year < 0 || month < 1 || month > 12) {
        return false;
    }

    if (month != 2) {
        if (day > ListOfDays[month - 1]) {
            return false;
        }
    }

    if (month == 2) {
        let leapYear = false;
        if ((!(year % 4) && year % 100) || !(year % 400)) {
            leapYear = true;
        }
        if (!leapYear && (day >= 29)) {
            return false;
        }
        if (leapYear && (day > 29)) {
            return false;
        }
    }

    const age = calculateAge(day, month, year)
    return ((age < 121) && (age > 17)) 
}

export function calculateAge(day, month, year) {
    const today = new Date();

    let age = today.getFullYear() - year;
    const m = today.getMonth() - (month - 1);
    if (m < 0 || (m === 0 && today.getDate() < day)) {
        age--;
    }
    
    return age
}

function removeError(formInput, errorId) {
    formInput.className = formInput.className.replace("coop-form__invalid", "");
    document.getElementById(errorId).innerHTML = "";
}

function addError(formInput, errorId, errorMessage) {
    formInput.className = formInput.className + " coop-form__invalid";
    document.getElementById(errorId).innerHTML = errorMessage;
}

export function isFormValid(form) {
    let dayEntered = form.dobDay.value;
    let monthEntered = form.dobMonth.value;
    let yearEntered = form.dobYear.value;

    const fullNameErrorMessage = !form.fullName.value ? "Enter your name" : "";
    const dobDayErrorMessage =
        !dayEntered && monthEntered && yearEntered ? "Enter a day of birth" : "";
    const dobMonthErrorMessage =
        !monthEntered && dayEntered && yearEntered ? "Enter a month of birth" : "";
    const dobYearErrorMessage =
        !yearEntered && dayEntered && monthEntered ? "Enter a year of birth" : "";
    const multipleDobErrorMessage =
        (!dayEntered && !monthEntered) ||
        (!dayEntered && !yearEntered) ||
        (!monthEntered && !yearEntered) ||
        !isDateOfBirthValid(dayEntered, monthEntered, yearEntered)
            ? "Enter a valid date of birth"
            : "";
    const phoneErrorMessage = !form.phone.value
        ? "Enter your contact number"
        : "";
    const referenceErrorMessage = !form.referenceNumber.value
        ? "Enter your reference number"
        : "";

    applyFieldValidation(form.fullName, "fullNameError", fullNameErrorMessage);
    applyFieldValidation(form.dobDay, "dobDayError", dobDayErrorMessage);
    applyFieldValidation(form.dobMonth, "dobMonthError", dobMonthErrorMessage);
    applyFieldValidation(form.dobYear, "dobYearError", dobYearErrorMessage);
    applyFieldValidation(
        form.dobDay,
        "dobMultipleError",
        multipleDobErrorMessage
    );
    applyFieldValidation(form.phone, "phoneError", phoneErrorMessage);
    applyFieldValidation(
        form.referenceNumber,
        "referenceError",
        referenceErrorMessage
    );

    var scrollToErrorId = "";
    if (fullNameErrorMessage) {
        scrollToErrorId = "fullNameError";
    } else if (
        dobDayErrorMessage ||
        dobMonthErrorMessage ||
        dobYearErrorMessage ||
        multipleDobErrorMessage
    ) {
        scrollToErrorId = "dobDayError";
    } else if (phoneErrorMessage) {
        scrollToErrorId = "phoneError";
    } else if (referenceErrorMessage) {
        scrollToErrorId = "referenceError";
    }

    if (scrollToErrorId) {
        location.href = "#" + scrollToErrorId;
        return false;
    }

    return true;
}

function zeroPad(num) { return String(num).padStart(2, '0') }

export function onCancelPlansSubmit() {
    const form = Bling.$(`.coop-form__cancel-plan`);

    const date_of_birth = `${zeroPad(form.dobDay.value)}/${zeroPad(form.dobMonth.value)}/${zeroPad(form.dobYear.value)}`

    if (!isFormValid(form)) {
        return false;
    }

    fetch(window.PLAN_CANCELLATION_API_URL, {
        method: "POST",
        body: JSON.stringify({
            ...Object.fromEntries(new FormData(form)),
            date_of_birth
        }),
        headers: {
            "x-api-key": window.PLAN_CANCELLATION_API_KEY,
            "content-type": "application/json"
        }
    }).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        window.location.href = `/funeralcare/plan-cancellation-form/confirmation-page`;
    }).catch(() => {
        window.location.href = `/funeralcare/plan-cancellation-form/plan-error?serviceName=${encodeURI("plan cancellation")}&returnUrl=/funeralcare/plan-cancellation-form`;
        return false;
    });
}
